import React, { useState } from 'react';
import { MessageSquare, X } from 'lucide-react';
import { messageLinks } from '../../config/contacts';

export default function ChatWidget() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="fixed bottom-4 right-4 z-50">
      {!isOpen && (
        <button
          onClick={() => setIsOpen(true)}
          className="bg-purple-600 text-white p-4 rounded-full shadow-lg hover:bg-purple-700 transition-colors"
          aria-label="Open chat"
        >
          <MessageSquare className="w-6 h-6" />
        </button>
      )}

      {isOpen && (
        <div className="w-96 bg-white dark:bg-gray-800 rounded-lg shadow-xl">
          <div className="p-4 bg-purple-600 text-white rounded-t-lg flex justify-between items-center">
            <h3 className="font-semibold">Message Us</h3>
            <button
              onClick={() => setIsOpen(false)}
              className="text-white hover:text-gray-200 transition-colors"
              aria-label="Close chat"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          <div className="p-6">
            <p className="text-gray-600 dark:text-gray-300 mb-4">
              Get in touch with us through any of these platforms:
            </p>
            <div className="space-y-4">
              {messageLinks.map((platform, index) => {
                const Icon = platform.icon;
                return (
                  <a
                    key={index}
                    href={platform.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center text-gray-700 dark:text-gray-300 hover:text-purple-600 dark:hover:text-purple-400"
                  >
                    <Icon className="w-5 h-5 mr-3 text-purple-600" />
                    <span>{platform.name}</span>
                  </a>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}